export default __webpack_public_path__ + "static/media/DMSans-Medium.45bdb87b.woff2";